import { mergeDeepRight } from "ramda";

function mergeDeepWithDefaults(
  sourceObj: Record<string, unknown>,
  defaults: Record<string, unknown>,
) {
  const res = {};
  const withDefaults = mergeDeepRight(defaults);
  Object.keys(sourceObj).forEach((key) => {
    res[key] = withDefaults(sourceObj[key] as Record<string, unknown>);
  });
  return res;
}

export default mergeDeepWithDefaults;
